import LocalizedStrings from 'react-localization';

export let LocalesModule = new LocalizedStrings({
    en: require('../locales/en.json'),
    // zh: require('../locales/zh.json'),
});
